import React, { useId } from 'react';
import { Box } from '@mui/material';
import { InterventionLadderStepModel } from '../../../api-service/clients';
import { intensityGradient, stepColor, stepIntensity, stepMarkerBorders } from './intervention-ladder-colors';

const viewBoxHeight = 90;
const lowestLine = 82;
const highestLine = 10;
const staircaseHeight = 132;

export interface InterventionLadderStaircaseProps {
  steps: InterventionLadderStepModel[];
}

export function InterventionLadderStaircase({ steps }: InterventionLadderStaircaseProps) {
  const gradientId = useId();
  const stepWidth = 1000 / steps.length;
  const rise = steps.length > 1 ? (lowestLine - highestLine) / (steps.length - 1) : 0;

  function lineHeight(index: number) {
    return lowestLine - index * rise;
  }

  const path = steps.map((_, index) => `${index === 0 ? `M0,${lineHeight(0)}` : `V${lineHeight(index)}`} H${(index + 1) * stepWidth}`).join(' ');

  return (
    <Box sx={{ position: 'relative', height: staircaseHeight, mb: 1 }} aria-hidden>
      <svg viewBox={`0 0 1000 ${viewBoxHeight}`} preserveAspectRatio="none" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
            {intensityGradient.map((color, index) => (
              <stop key={color} offset={index / (intensityGradient.length - 1)} stopColor={color} />
            ))}
          </linearGradient>
        </defs>
        <path d={path} fill="none" stroke={`url(#${gradientId})`} strokeWidth={5} strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
      </svg>
      {steps.map((step, index) => (
        <Box
          key={step.step}
          sx={{
            position: 'absolute',
            left: `${((index + 0.5) / steps.length) * 100}%`,
            top: (lineHeight(index) / viewBoxHeight) * staircaseHeight,
            transform: 'translate(-50%, -50%)',
            width: 26,
            height: 26,
            borderRadius: '50%',
            bgcolor: '#ffffff',
            border: `2px solid ${stepColor(stepMarkerBorders, stepIntensity(index, steps.length))}`,
            color: '#1f4d61',
            fontSize: '0.8rem',
            fontWeight: 700,
            display: 'grid',
            placeItems: 'center',
            boxShadow: '0 1px 4px rgba(24, 76, 97, 0.22)',
          }}
        >
          {step.step}
        </Box>
      ))}
    </Box>
  );
}
